import { RouteObject } from "react-router-dom";

import WebinarsList from "pages/EventsPage/EventsList";
import AttendanceRecords from "pages/EventsPage/AttendanceRecords";
import { AttendanceRecordsDownloadPage } from "pages/AttendanceRecordsDownloadPage";

export const eventsRoutes: RouteObject[] = [
  { index: true, element: <WebinarsList /> },
  { path: "skus/-/:id/organization/attendance-records", element: <AttendanceRecords /> },
  { path: "skus/-/:id/attendance-records/download/:fileId", element: <AttendanceRecordsDownloadPage /> },
];
